<template>
  <div
    class="operation-record-page tb"
    v-if="funcView.simOperationRecord_list"
  >
    <div class="search-hd">
      <el-form
        :inline="true"
        @submit.native.prevent
      >
        <!-- 配置项 -->
        <el-form-item style="float: right">
          <custom-column
            :code="tableCode"
            v-model="tableColumn"
          ></custom-column>
        </el-form-item>
        <!-- 搜索项 -->
        <el-form-item style="float: right">
          <search-input
            v-model="formSearch.search"
            :placeholder="$t('dms_operationRecord.IMSIjshModemSN')"
            @fetch="onPageChange({ page: 1 })"
          ></search-input>
        </el-form-item>
        <el-form-item style="float: right">
          <switch-button :link="link"></switch-button>
        </el-form-item>
      </el-form>
    </div>
    <switch-container
      ref="container"
      @search="onPageChange({ page: 1 })"
      @clear="clearFilter()"
    >
      <el-form
        :inline="true"
        label-position="top"
      >
        <el-form-item :label="$t('dms_operationRecord.cao_zuo_shi_jian')">
          <custom-date-picker
            style="width: 100%"
            v-model="formSearch.operateTime"
            type="daterange"
            align="right"
            value-format="YYYY-MM-DD HH:mm:ss"
          ></custom-date-picker>
        </el-form-item>
      </el-form>
    </switch-container>
    <div class="table-bd">
      <custom-table
        height="100%"
        :data="tableList"
        :column="tableColumn"
        :index="true"
        @filter="filterChange"
        @sort="sortChange"
      >
      </custom-table>
    </div>
    <div class="table-page">
      <custom-page
        :total="totalRows"
        :page="formSearch.pageNum"
        :size="formSearch.pageSize"
        @change="onPageChange"
      ></custom-page>
    </div>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import resetFormSearchMixins from '@/mixins/reset_form_search_mixins';

export default {
  name: 'simOperationRecord',
  mixins: [resetFormSearchMixins],
  components: {},
  data() {
    return {
      tableCode: 'sim_update_record',
      dialogVisible: false,
      dialogModel: {},
      productId: '',
      productTotal: 0,

      formSearch: {
        search: '',
        orderType: '',
        orderBy: '',
        pageSize: 50,
        pageNum: 1,
        operateTime: [],
      },
      tableList: [],
      totalRows: null,
      link: null,
    };
  },
  activated: function () {
    this.getTableList();
  },
  computed: {
  },
  watch: {
  },
  mounted() {
    this.resetForm = JSON.stringify(this.form);
    this.resetFormSearch = JSON.stringify(this.formSearch);

    this.getFuncView(null, () => {
      setTimeout(() => {
        this.link = this.$refs.container;
      }, 500);
    });

    this.getTableColumn();
  },
  methods: {
    getTableListReqData() {
      const ret = {
        ...this.formSearch
      };

      const operateTime = ret.operateTime;
      if (operateTime && operateTime.length) {
        const operateTimeStartTime = operateTime[0];
        const operateTimeEndTime = operateTime[1];
        ret.operateTimeStartTime = operateTimeStartTime;
        ret.operateTimeEndTime = operateTimeEndTime;
      }

      delete ret.operateTime;

      return ret;
    },
    // 获取列表
    getTableList: function () {
      const reqData = this.getTableListReqData();
      this.$getJSON(apis.simStatePage, reqData).then((res) => {
        this.tableList = res.data.list;
        this.totalRows = res.data.total;
      });
    },
    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getTableList();
    },
  },
};
</script>

<style lang="scss">
@import 'style/colors.scss';

.operation-record-page {
}
</style>
